import React, { useEffect, useState } from 'react';
import ManagerDashboard from 'layouts/ManagerDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getItem } from './ItemService';
import { useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import { format } from 'date-fns';
import { toDate } from 'date-fns-tz';

import ItemChildrenList from './ItemChildrenList';
import ItemDocumentList from './ItemDocumentList';
import ItemAttachmentList from './ItemAttachmentList';
import ItemAssignmentList from './ItemAssignmentList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
const ItemDetail = (): JSX.Element => {
  const [name, setName] = useState('');
  const [sectionId, setSectionId] = useState('');
  const [description, setDescription] = useState('');
  const [versionNumber, setVersionNumber] = useState('');
  const [buildNumber, setBuildNumber] = useState('');
  const [status, setStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { itemid } = useParams();
  const { subscriptionid } = useParams();

  useEffect(() => {
    if (itemid) {
      console.log('Itemid exists: ', itemid);
      getItem(itemid)
        .then((response) => {
          console.log(response.data);
          setName(response.data.name);
          setVersionNumber(response.data.versionNumber);
          setBuildNumber(response.data.buildNumber);
          setStatus(response.data.status);
          setStartDate(response.data.startDate);
          setEndDate(response.data.endDate);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [subscriptionid, itemid]);

  const timeZone = 'Europe/London';
  const formatString = 'dd-MM-yyyy HH:mm:ss';

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const zonedDate = toDate(date, { timeZone });
    return format(zonedDate, formatString);
  };

  return (
    <Container>
      <ManagerDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Your Apps
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={`/dashboard/dashboard/items/section/${sectionId}`}
            >
              Apps
            </Link>
            <Typography color="text.primary">App Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Box sx={{ width: '65%' }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginBottom={4}
            >
              <Typography variant="h4">App Detail</Typography>
            </Box>

            <Box>
              <form>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Name
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'name'}
                      fullWidth
                      value={name} // Use the 'sequence' state variable as the value
                      onChange={(event) => setName(event.target.value)} // Update the 'sequence' state variable on change
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Section ID
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'sectionId'}
                      fullWidth
                      value={sectionId} // Use the 'name' state variable as the value
                      onChange={(event) => setSectionId(event.target.value)} // Update the 'name' state variable on change
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Description
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'description'}
                      fullWidth
                      value={description} // Use the 'name' state variable as the value
                      onChange={(event) => setDescription(event.target.value)} // Update the 'name' state variable on change
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Version Number
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'versionNumber'}
                      fullWidth
                      value={versionNumber} // Use the 'name' state variable as the value
                      onChange={(event) => setVersionNumber(event.target.value)} // Update the 'name' state variable on change
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Build Number
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'buildNumber'}
                      fullWidth
                      value={buildNumber} // Use the 'name' state variable as the value
                      onChange={(event) => setBuildNumber(event.target.value)} // Update the 'name' state variable on change
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Status
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'status'}
                      fullWidth
                      value={status} // Use the 'name' state variable as the value
                      onChange={(event) => setStatus(event.target.value)} // Update the 'name' state variable on change
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Start Date
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'startDate'}
                      fullWidth
                      value={formatDate(startDate)}
                      onChange={(event) => setStartDate(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      End Date
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'endDate'}
                      fullWidth
                      value={formatDate(endDate)}
                      onChange={(event) => setEndDate(event.target.value)}
                    />
                  </Grid>
                  <Grid item container xs={12}>
                    <Box
                      display="flex"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      alignItems={{ xs: 'stretched', sm: 'center' }}
                      justifyContent={'space-between'}
                      width={1}
                      //margin={'0 auto'}
                      marginBottom={4}
                    ></Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Box>

          {/* New Box - 30% of Screen Width */}
          <Box sx={{ width: '30%', marginLeft: '30px' }}>
            <ItemAssignmentList
            // itemName={name}
            // startDate={startDate}
            // endDate={endDate}
            />
          </Box>
        </Box>

        <Box>
          <ItemChildrenList parentId={itemid} sectionId={1} />
          <ItemDocumentList itemId={itemid} />
          <ItemAttachmentList itemId={itemid} />
        </Box>
      </ManagerDashboard>
    </Container>
  );
};

export default ItemDetail;
